<template>
  <div class="Whole">
    <!-- 全部可见 -->
    <div class="Functional-classification">
      <p class="titles">功能分类</p>
      <template v-for="(v, i) in classification">
        <!-- v-if="CodeKey[v.code]" -->
        <template>
          <div :key="i" class="Function-display" @click="functionJump(v.title)">
            <img :src="v.img" width="50vh" />
            <p style="margin-top: 15px">{{ v.title }}</p>
          </div>
        </template>
      </template>
    </div>
    <!-- <div class="Functional-classification">
      <p class="titles">小工具</p>
      <template v-for="(v, i) in Gadgets">
        <div :key="i" class="Gadgets-display" @click="functionJump(v.title)">
          <img :src="v.img" width="50vh" />
          <p style="margin-top: 15px">{{ v.title }}</p>
        </div>
      </template>
    </div> -->
  </div>
</template>

<script>
import { setToken, getToken } from '@/utils/localstorage'
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      currentUserType: 0,
      kingdeeDataUser: false,
      classification: [
        {
          title: '核算组',
          img: '../../../static/img/function_img/AccountingGroup.png',
          code: 'zcmHs',
        },
        {
          title: '税务组',
          img: '../../../static/img/function_img/TaxGroup.png',
          code: 'zcmSw',
        },
        {
          title: '基础信息',
          img: '../../../static/img/function_img/BasicInformation.png',
          code: 'zcmBase',
        },
        {
          title: '开票中心',
          img: '../../../static/img/function_img/BillingCenter.png',
          code: 'zcmInvoice',
        },
        {
          title: '费用中心',
          img: '../../../static/img/function_img/Operation.png',
          code: 'costCenter',
        },
      ],
      CodeKey: {},
    }
  },
  computed: {
    // resourceCode() {
    //   return getToken('resourceList')
    // },
  },
  mounted() {
    // 判断是否有权限码
    // this.resourceCode.forEach(v => {
    //   this.CodeKey[v.code] = true
    // })
    // if (
    //   this.CodeKey['zcmSelfInvoice'] ||
    //   this.CodeKey['zcmPlanInvoice'] ||
    //   this.CodeKey['zcmUnorderInvoice']
    // ) {
    //   this.CodeKey['zcmInvoice'] = true
    // }
    // this.classification = [...this.classification]
  },
  methods: {
    functionJump(e) {
      this.$store.commit('setting/setSystemName', '招财猫')
      switch (e) {
        case '核算组':
          this.$router.push('/zcm/board/hourly_order')
          break
        case '税务组':
          this.$router.push('/zcm/board/Invoice_input')
          break
        case '基础信息':
          this.$router.push('/zcm/board/employee_information')
          break
        case '开票中心':
          setToken('puths', '/zcm/board/Billing_center')
          this.$router.push('/zcm/board/Billing_center')
          break
        case '费用中心':
          this.$router.push('/zcm/board/costCenter/AlipayDocuments')
          break
      }
    },
  },
}
</script>
<style scoped>
.Functional-classification {
  width: 800px;
  height: 400px;
  background-color: white;
  margin: 20px auto;
}
.Function-display {
  float: left;
  margin-left: 4.5rem;
  margin-top: 30px;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
}
.Gadgets-display {
  float: left;
  margin-left: 4rem;
  margin-top: 20px;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
}
.titles {
  width: 75px;
  margin-left: 20px;
  position: relative;
  top: 25px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: rgba(9, 35, 84, 1);
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue